<div class="mb-2">
    <label class="form-label" translate="patient.modal.replace-kit.shipping-address"></label>
    <div class="shipping-address">{{ address }}</div>
    <div *ngIf="instructions"><span translate="patient.modal.replace-kit.instructions"></span> {{ instructions }}</div>
    <div *ngIf="incomplete" class="shipping-address-incomplete" translate="patient.modal.replace-kit.incomplete-address"></div>
</div>
